/**
 * Returns one `YYYY-MM-DD` label for every UTC calendar day in the inclusive
 * range, so DST never skips or duplicates a day.
 *
 * @param startIso - The first calendar date in `YYYY-MM-DD` format.
 * @param endIso - The final calendar date in `YYYY-MM-DD` format.
 * @returns Consecutive UTC calendar-date labels, including both bounds.
 */
export const dailyDateRange = (startIso: string, endIso: string): string[] => {
  const dates: string[] = [];
  const current = new Date(`${startIso}T00:00:00Z`);
  const end = new Date(`${endIso}T00:00:00Z`);
  while (current <= end) {
    dates.push(current.toISOString().slice(0, 10));
    current.setUTCDate(current.getUTCDate() + 1);
  }
  return dates;
};
